import {
  Component, Input, TemplateRef, ViewChild
} from '@angular/core';
import { ContextService } from '@core/services/core/context.service';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { IonRouterOutlet } from '@ionic/angular';

@Component({
  selector: 'mapfre-whitebox-layout',
  templateUrl: './mapfre-whitebox-layout.component.html',
  styleUrls: ['./mapfre-whitebox-layout.component.scss']
})
export class MapfreWhiteBoxLayout {

  @ViewChild('toolbar', { static: false }) toolbar;
  @Input() title: string;
  @Input() headerType: 'normal' | 'big' = 'normal';
  @Input() mapfreAppHeader?: boolean;
  @Input() disableBackButton?: boolean;
  @Input() disableCancelButton? = true;
  @Input() headerIconSrc?: string;
  @Input() progress?: number;
  @Input() menuButton?: boolean;
  @Input() onCancel?: () => void;
  @Input() onBack?: () => void;

  @Input() whiteBoxOuter?: TemplateRef<any>;

  constructor(
    public ctx: ContextService,
    public routerOutlet: IonRouterOutlet,
    private nav: NavigationHelper
  ) {}

  _onBack($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.onBack
      ? this.onBack()
      : this.nav.pop();
  }

  _onCancel($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.onCancel
      ? this.onCancel()
      : this.nav.goHomePage();
  }

}
